import {sameEdit} from './edit-patch'

const clone = value => JSON.parse(JSON.stringify(value || {}))

// Snapshots retain their own document lineage across navigation. Accepted
// writes can finish and rebase a queued save without changing a replacement
// view's draft or submitting fields that were never edited.
export function createDocumentEdits(keyField='id') {
    let lineage:any, revision=0, dirty=false
    return {
        initialize(value:any,location=value?.[keyField]) {
            lineage={key:value?.[keyField],location,baseline:clone(value)};revision++;dirty=false
        },
        clear(){lineage=undefined;revision++;dirty=false},
        change(){revision++;dirty=true},
        capture(value:any){return{draft:clone(value),lineage,revision}},
        current(snapshot){return !!snapshot.lineage && snapshot.lineage===lineage},
        unchanged(snapshot){return !!snapshot.lineage && snapshot.lineage===lineage && snapshot.revision===revision},
        patch(snapshot,fields:string[]) {
            const baseline=snapshot.lineage?.baseline
            return Object.fromEntries(fields.filter(field=>Object.hasOwn(snapshot.draft,field)
                && (!baseline?._id || !sameEdit(snapshot.draft[field],baseline[field])))
                .map(field=>[field,snapshot.draft[field]]))
        },
        acknowledge(snapshot,value:any,location=snapshot.lineage?.location) {
            if(!snapshot.lineage)return false
            snapshot.lineage.key=value?.[keyField];snapshot.lineage.location=location;snapshot.lineage.baseline=clone(value)
            const unchanged=this.unchanged(snapshot)
            if(snapshot.lineage===lineage)dirty=!unchanged
            return unchanged
        },
        get lineage(){return lineage},
        get dirty(){return dirty},
    }
}
